module.exports = __webpack_public_path__ + "static/test-90c1a8a597bb8055ce1750afd2bc242f.jpg";